import type { IntlShape } from 'react-intl'

import { getUnit, kmToFeet, kmToMiles, roundToNearest } from 'lib/geo/distanceUnits'

function formatOneDecimalNumber(intl: IntlShape, value: number): string {
  return intl.formatNumber(value, {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  })
}

export function formatNearbyPlaceDistance(
  intl: IntlShape,
  distanceM: number,
  regionCode: string,
): string {
  const unit = getUnit(regionCode)

  if (unit === 'mi') {
    const distanceKm = distanceM / 1000
    if (distanceKm < 0.2) {
      return intl.formatMessage(
        {
          id: 'RLdCjyRYg7VuJSIoV7g9',
          defaultMessage: '{distance} ft',
          description: 'Straight-line distance to a nearby place shown in feet on the offer page surroundings section',
        },
        { distance: roundToNearest(kmToFeet(distanceKm), 10) },
      )
    }

    return intl.formatMessage(
      {
        id: '5NRp5nLpvpwmpLoVZlBq',
        defaultMessage: '{distance} mi',
        description: 'Straight-line distance to a nearby place shown in miles on the offer page surroundings section',
      },
      { distance: formatOneDecimalNumber(intl, kmToMiles(distanceKm)) },
    )
  }

  if (distanceM < 1000) {
    return intl.formatMessage(
      {
        id: 'lJ2yVOlXSKPO0_sbun85',
        defaultMessage: '{distance} m',
        description: 'Straight-line distance to a nearby place shown in metres on the offer page surroundings section',
      },
      { distance: roundToNearest(distanceM, 10) },
    )
  }

  return intl.formatMessage(
    {
      id: 'PPP7f4A3qKZ0Tg9YNo1e',
      defaultMessage: '{distance} km',
      description: 'Straight-line distance to a nearby place shown in kilometres on the offer page surroundings section',
    },
    { distance: formatOneDecimalNumber(intl, distanceM / 1000) },
  )
}
